import { BaseWalletConnect } from './client';
import type { WalletConnectConfig } from './types';

export class OneDollarConnect extends BaseWalletConnect {
  constructor(config: Omit<WalletConnectConfig, 'walletId'>) {
    super({ ...config, walletId: 'onedollar' });
  }
}
